import React, { useEffect } from "react";

interface SuccessPopupProps {
  message: string;
  onClose: () => void;
}

const SuccessPopup: React.FC<SuccessPopupProps> = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 15000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="containerLayer">
      <div className="containerInterieur2">
        <div className="TextInscription">Merci !</div>
        <div className="TextInscription">{message}</div>
        <div className="TextInscription">
          Si vous ne recevez pas l'email de confirmation, veuillez vérifier dans
          votre boîte SPAM ou attendez quelques minutes.
        </div>
        <div className="TextInscription">
          Vous allez revenir sur la page d'ici quelques secondes.
        </div>
        <div className="TextInscription">À bientôt !</div>
      </div>
    </div>
  );
};

export default SuccessPopup;

/*
return (
    <div className="containerLayer">
      <p className="textPopup">Merci !</p>
      <p className="textPopup">{message}</p>
      <p className="textPopup">
        Si vous ne recevez pas l'email de confirmation, veuillez vérifier dans
        votre boîte SPAM ou attendez quelques minutes.
      </p>
      <p className="textPopup">
        Vous allez revenir sur la page d'ici quelques secondes.
      </p>
      <p className="textPopup">À bientôt !</p>
    </div>
  );
*/

/*

  <div className="containerLayer">
          <div className="containerInterieur">
            <div className="TitreInscription">
              Merci d'indiquer l'adresse e-mail avec laquelle vous vous êtes
              inscrit pour accéder au live :
            </div>

            <input
              type="email"
              name="email"
              className="inputVille"
              required
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              placeholder="E-mail* "
            />

            <div className="robot">
              <input
                type="radio"
                id="robot"
                name="robot"
                checked={robotChecked}
                onChange={() => setRobotChecked(true)}
              />
              <label htmlFor="robot"> Je ne suis pas un robot !</label>
            </div>

            <div className="btnValider3" onClick={handleEmailSubmit}>
              ACCÉDER AU LIVE
            </div>
          </div>
        </div>
 */
